import { UserManager, WebStorageStateStore, Log } from 'oidc-client';

const config = {
    authority: process.env.REACT_APP_AUTHORITY,
    client_id: process.env.REACT_APP_CLIENT_ID,
    post_logout_redirect_uri: process.env.REACT_APP_POST_REDIRECT,
    redirect_uri: process.env.REACT_APP_REDIRECT,
    response_type: 'code',
    // scope: 'openid AgentDashboard',
    scope: 'openid AgentDashboard AdminDashboard',
};

export default class AuthService {
    userManager;

    constructor() {
        this.userManager = new UserManager({
            ...config,
            userStore: new WebStorageStateStore({ store: window.sessionStorage }),
        });
        // Logger
        Log.logger = console;
        Log.level = Log.INFO;

        this.userManager.events.addUserLoaded((user) => {
            if (window.location.href.indexOf('signin-oidc') !== -1) {
                this.navigateToScreen();
            }
        });

        this.userManager.events.addAccessTokenExpired((e) => {
            console.log('token expired');
        });
    }

    signinRedirectCallback = () => {
        this.userManager.signinRedirectCallback().then(() => {
            console.log('signinRedirectCallback');
            window.location.replace('/customer/bookings');
        });
    };

    getUser = async () => {
        const user = await this.userManager.getUser();
        if (!user) {
            return await this.userManager.signinRedirectCallback();
        }
        return user;
    };

    parseJwt = (token: string) => {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    };

    signinRedirect = () => {
        localStorage.setItem('redirectUri', window.location.pathname + window.location.search);
        this.userManager.signinRedirect({});
    };

    navigateToScreen = () => {
        const userRedirectUri = localStorage.getItem('redirectUri');
        if (userRedirectUri) {
            window.location.replace(userRedirectUri);
        } else {
            window.location.replace('/customer/bookings');
        }
    };

    isAuthenticated = () => {
        const oidcStorage = JSON.parse(
            sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTHORITY}:${process.env.REACT_APP_CLIENT_ID}`)
        );
        return !!oidcStorage && !!oidcStorage.access_token;
    };

    createSigninRequest = () => {
        return this.userManager.createSigninRequest();
    };

    logout = () => {
        this.userManager.signoutRedirect({
            id_token_hint: localStorage.getItem('id_token'),
        });
        this.userManager.clearStaleState();
    };

    signoutRedirectCallback = () => {
        this.userManager.signoutRedirectCallback().then(() => {
            localStorage.clear();
            window.location.replace('/');
        });
        this.userManager.clearStaleState();
    };
}
